import { useCallback, useEffect, useRef, useState } from "react";
import supabase from "../supabaseClient";
import { useAppIssueContext } from "../context/appIssueContext";

declare global {
  interface Window {
    pell: any;
  }
}

export default function IssueForm() {
  const { username, country, session } = useAppIssueContext() as { username: string; country: string; session: string };
  const [issue, setIssue] = useState("");
  const [title, setTitle] = useState("");
  // const toast = useToast();
  const [isSending, setIsSending] = useState(false);

  const editor = useRef<{ content: HTMLElement }>({ content: {} } as { content: HTMLElement });

  const handleSubmit = useCallback(
    async (e: any) => {
      e.preventDefault();
      setIsSending(true);
      if (!issue) return;

      setIssue("");

      try {
        const { error } = await supabase.from("issues").insert([
          {
            text: issue,
            username,
            country,
            title,
            is_authenticated: session ? true : false,
          },
        ]);

        // if (error) {
        //   console.error(error.issue);
        //   toast({
        //     title: "Error sending",
        //     description: error.issue,
        //     status: "error",
        //     duration: 9000,
        //     isClosable: true,
        //   });
        //   return;
        // }
        console.log("Sucsessfully sent!");
        if (editor.current) {
          editor.current.content.innerHTML = "";
        }
      } catch (error) {
        console.log("error sending issue:", error);
      } finally {
        setIsSending(false);
      }
    },
    [issue, title, editor.current],
  );

  useEffect(() => {
    // Initialize pell on an HTMLElement
    editor.current = window.pell.init({
      element: document.getElementById("editor_issue"),

      // <Function>, required
      // Use the output html, triggered by element's `oninput` event
      onChange: (html: string) => {
        setIssue(html);
      },

      // <string>, optional, default = 'div'
      // Instructs the editor which element to inject via the return key
      defaultParagraphSeparator: "hr",

      // <boolean>, optional, default = false
      // Outputs <span style="font-weight: bold;"></span> instead of <b></b>
      styleWithCSS: false,

      actions: [
        "bold",
        "underline",
        "strikethrough",
        "italic",
        "heading1",
        "heading2",
        "olist",
        "ulist",
        "code",
        "paragraph",
        "line",
      ],
      classes: {
        // actionbar: "pell-actionbar-custom-name",
        // button: "pell-button-custom-name",
        // content: "pell-content-custom-name",
        // selected: "pell-button-selected-custom-name",
      },
    });
  }, []);

  return (
    <div>
      <div>
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="d-flex flex-column">
            <input
              name="message"
              placeholder="Title"
              onChange={(e) => setTitle(e.target.value)}
              value={title}
              className="form-control form-control-lg"
              maxLength={500}
            />
            <div id="editor_issue" className="pell mt-2"></div>
            <button className="btn btn-primary mt-2 align-self-end" type="submit" disabled={!issue}>
              Envoyer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
